module.exports = __webpack_public_path__ + "img/map_user.0cc26fa2.png";